import {
  ActivityReportingRequirementsViewModel,
  UpdateActivityReportingRequirementsModel
} from '../../../../features/activities/editActivity/editReportingRequirements/types';
import { CompanyDivisionBookingOption } from '../../../company/edit/types/companyDivisionBookingOption';

export const getReportingRequirementsInitialEditModel = (
  reportingRequirementsModel: ActivityReportingRequirementsViewModel | undefined
) => {
  const toReturn: UpdateActivityReportingRequirementsModel = {
    CompanyReportingRequirements: [],
    TravellerReportingRequirements: []
  };

  if (reportingRequirementsModel) {
    toReturn.CompanyReportingRequirements.push(
      ...reportingRequirementsModel.CompanyReportingRequirements.map((val) => {
        return {
          BookingRequirementId: val.BookingRequirementId,
          ReportingRequirementId: val.ReportingRequirementId,
          Value: val.Value,
          OptionValues: []
        };
      })
    );

    reportingRequirementsModel.TravellerReportingRequirements.forEach((val) => {
      toReturn.TravellerReportingRequirements.push(
        ...val.ReportingRequirements.map((tr) => {
          return {
            BookingRequirementId: tr.BookingRequirementId,
            ReportingRequirementId: tr.ReportingRequirementId,
            Value: tr.Value,
            OptionValues: [],
            TravellerId: tr.TravellerId
          };
        })
      );
    });
  }
  return toReturn;
};

export const applyCompanyDivisionReportingRequirementPresets = (
  model: UpdateActivityReportingRequirementsModel,
  divisions: CompanyDivisionBookingOption[],
  companyDivisionId: number | undefined
): UpdateActivityReportingRequirementsModel => {
  const controlledRequirementIds = new Set(
    divisions.flatMap((division) => division.ReportingRequirementValues.map((value) => value.ReportingRequirementId))
  );
  const selectedPresets = new Map(
    divisions
      .find((division) => division.Id === companyDivisionId)
      ?.ReportingRequirementValues.map((value) => [value.ReportingRequirementId, value.Value]) ?? []
  );

  return {
    ...model,
    CompanyReportingRequirements: model.CompanyReportingRequirements.map((requirement) =>
      controlledRequirementIds.has(requirement.ReportingRequirementId)
        ? { ...requirement, Value: selectedPresets.get(requirement.ReportingRequirementId) ?? '' }
        : requirement
    )
  };
};
